import { questionConstants } from '../constants';

const initialState = {
    loading: false,
    questions: [],
    error: null,
    creatingQuestion: false,
    createError: null,
    updatingQuestion: false,
    updateError: null,
};

const questionReducer = (state = initialState, action) => {
    switch (action.type) {
        case questionConstants.FETCH_QUESTIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case questionConstants.FETCH_QUESTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                questions: action.questions,
                error: null
            };
        case questionConstants.FETCH_QUESTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case questionConstants.CREATE_QUESTION_REQUEST:
            return {
                ...state,
                creatingQuestion: true,
                createError: null,
            };
        case questionConstants.CREATE_QUESTION_SUCCESS:
            return {
                ...state,
                creatingQuestion: false
            };
        case questionConstants.CREATE_QUESTION_FAILURE:
            return {
                ...state,
                creatingQuestion: false,
                createError: action.payload,
            };
        case questionConstants.UPDATE_QUESTION_REQUEST:
            return {
                ...state,
                updatingQuestion: true,
                updateError: null,
            };
        case questionConstants.UPDATE_QUESTION_SUCCESS:
            return {
                ...state,
                questions: action.questions,
                updatingQuestion: false,
                updateError: null,
            };
        case questionConstants.UPDATE_QUESTION_FAILURE:
            return {
                ...state,
                updatingQuestion: false,
                updateError: action.payload,
            };
        case questionConstants.DELETE_QUESTION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case questionConstants.DELETE_QUESTION_SUCCESS:
            return {
                ...state,
                loading: false,
                questions: state.questions.filter(q => q.QuestionID !== action.payload),
            };
        case questionConstants.DELETE_QUESTION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case questionConstants.UPDATE_QUESTIONSEQUENCE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case questionConstants.UPDATE_QUESTIONSEQUENCE_SUCCESS:
            return {
                ...state,
                loading: false,
                questions: action.questions
            };
        case questionConstants.UPDATE_QUESTIONSEQUENCE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default questionReducer;
